import { render } from "./AddItem.vue?vue&type=template&id=c38fcae8"
import script from "./AddItem.vue?vue&type=script&lang=js"
export * from "./AddItem.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__